<template>
    <div class="mt-4">
        <div class="collapse" :id="collapseId" :data-parent="parentCollapseId">
            <div class="row">
            </div>

            <div v-if="showBottomSpacer" class="pt-10"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            collapseId: {
                type: String,
                default: '',
            },
            parentCollapseId: {
                type: String,
                default: '',
            },
            showActiveFilters: {
                type: Boolean,
                default: true,
            },
            showBottomSpacer: {
                type: Boolean,
                default: false,
            },
            idPrefix: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
            };
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/cinemas/CityCinemaFiltersMobile.vue